"use strict";
const isTest = process.env.ENVIRONMENT === "test";
const isLocal = process.env.ENVIRONMENT === "local";
const isDev = process.env.ENVIRONMENT === "dev";
const isStaging = process.env.ENVIRONMENT === "staging";
const isProd = process.env.ENVIRONMENT === "prod";
const isLocalOrTest = isLocal || isTest;
const isDevOrLocal = isDev || isLocal;
const isDevOrLocalOrTest = isDevOrLocal || isTest;
const isCI = process.env.GITHUB_ACTIONS !== undefined;
const isGatherScripts = process.env.IS_GATHER_SCRIPTS !== undefined;
const isUnitTest = isTest && process.env.NODE_ENV === "test";
module.exports = {
    isTest,
    isLocal,
    isDev,
    isStaging,
    isProd,
    isLocalOrTest,
    isDevOrLocal,
    isDevOrLocalOrTest,
    isCI,
    isGatherScripts,
    isUnitTest,
};
//# sourceMappingURL=envShared.js.map